// extracted by mini-css-extract-plugin
export var closeButton = "_gs-2";
export var closeButtonIcon = "_gs-3";
export var lightboxContent = "_gs-1";
export var lightboxOverlay = "_gs-0";